// extracted by mini-css-extract-plugin
module.exports = {"newsWrap":"news_newsWrap__kEJlr"};